import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { App } from './App'
import { OverviewPage } from './pages/OverviewPage'
import { SchedulePage } from './pages/SchedulePage'
import { PhotosPage } from './pages/PhotosPage'
import { SelectionsPage } from './pages/SelectionsPage'
import { ChangeOrdersPage } from './pages/ChangeOrdersPage'
import { MessagesPage } from './pages/MessagesPage'
import { WelcomeHomePage } from './pages/WelcomeHomePage'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('root element missing')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<OverviewPage />} />
          <Route
            path="projects/:projectId"
            element={<Navigate to="schedule" replace />}
          />
          <Route path="projects/:projectId/schedule" element={<SchedulePage />} />
          <Route path="projects/:projectId/photos" element={<PhotosPage />} />
          <Route
            path="projects/:projectId/selections"
            element={<SelectionsPage />}
          />
          <Route
            path="projects/:projectId/change-orders"
            element={<ChangeOrdersPage />}
          />
          <Route path="projects/:projectId/messages" element={<MessagesPage />} />
          <Route
            path="projects/:projectId/welcome-home"
            element={<WelcomeHomePage />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
